import React , {Component} from 'react'
import { connect } from 'react-redux'
import classnames from 'classnames'

class SideDirectory extends Component {

  constructor(props) {
      super(props)
      this.state = {
        element: 0
      };
  }

  componentDidMount() {
    window.addEventListener('scroll', this.handleScroll);
  }

  handleScroll = (e) => {
    let ids = ['landing-page-hero', 'seamless-rsvp-invitation', 'customizable-rsvp-invitation-form', 'post-event-survey-data-analytics', 'user-friendly-attendance-system', 'bespoke-branding']

    ids.map((id, index) => {
      let element = document.getElementById(id).getBoundingClientRect().y
      let elementHeight = document.getElementById(id).getBoundingClientRect().height
      if (element <= 0 + elementHeight/2 && element >= -elementHeight/2) {
        this.setState({element: index})

      }
    })
  };

  componentWillUnmount() {
    window.removeEventListener('scroll', this.handleScroll);
  }

  render () {
    let sideDirectoryList = ['Home', 'Invite', 'Ask', 'Data', 'Live', 'Brand']
    return (
      <div style={{position: 'fixed', top: '30vh', zIndex: '10'}} className={classnames('side-directory', {'side-directory-white': this.state.element === 0 || this.state.element === 2 || this.state.element === 5})}>
        {
          sideDirectoryList.map((text, index) => {
            if (this.state.element === index) {
              return (
                <div key={text} className='side-directory--section-highlighted mb-1'><div className='side-directory--section-highlighted--text'>{text}</div></div>
              )
            } else {
              return (
                <div key={text} className='side-directory--section-normal mb-1' />
                )
            }
          })
        }
      </div>
    )
  }
}

const mapStateToProps = ( state, props ) => ({

})

const mapDispatchToProps ={

    }

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(SideDirectory)


// WEBPACK FOOTER //
// ./src/components/landing/SideDirectory.js